import styles from './GitHubActions.module.scss'
import Contact from '../pages/Contact'
import BestPractice from '../pages/BestPractice'
import Features from '../pages/Features'
import Introduction from '../pages/Introduction'
import Top from '../pages/Top'
import Flow from '../pages/Flow'
import PriceList from '../pages/PriceList'
import QA from '../pages/QA'
import CallToAction from '../pages/CallToAction'
import Architecture from '../pages/Architecture'
import { useRef } from 'react'
import useScrollHideContact from '../hooks/useScrollHideContact'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import NewsLp from '../pages/NewsLp'

const ContactFormId = '1187bc04-99fb-4fdb-a4ab-431d40315317'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'GitHub Actions', url: '#' },
]

const TopContents = {
  smallTitle: 'ワークフローの自動化で開発を加速',
  title: ['GitHub Actionsで実現する', '効率的なCI/CD'],
  text: 'リポジトリに統合された強力な自動化ツールで、開発からデプロイまでをシームレスに連携させます。',
  imgLink: '/images/LP/LP202407/Logo/LogoGitHubActions.png',
}

const IntroductionContents = {
  title: '開発プロセスの自動化に、こんな悩みはありませんか？',
  list: [
    {
      text: ['複数のツールを組み合わせてCI/CDパイプラインを構築するのが煩雑'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsBezier2.svg',
    },
    {
      text: ['コードレビュー・テスト・デプロイの連携が円滑でない'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsColumnsGap.svg',
    },
    {
      text: ['チーム間でのワークフローの標準化が難しい'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsDiagram3.svg',
    },
  ],
}
const BestPracticeContents = {
  heading: ['GitHub Actionsで', '開発ワークフローを最適化し、', '生産性を向上させます'],
  text: [
    'AitriaのGitHub Actions導入支援サービスは、開発プロセスの自動化と効率化を目指す企業に最適です。',
    'コードのビルド、テスト、デプロイを自動化し、開発からリリースまでのサイクルを大幅に短縮。',
    '柔軟なワークフロー設計により、お客さま固有のニーズに合わせたCI/CD環境を構築します。',
    '当社の専門家チームが、最適なGitHub Actions環境の設計から運用までをトータルでサポートします。',
  ],
}

const ArchitectureContents = {
  title: 'GitHub Actions',
  imgLink: ['/images/LP/LP202407/Architectures/architecture-githubactions.png'],
}

const FeaturesContents = {
  title: 'GitHub Actions',
  items: [
    {
      num: '01',
      itemTitle: 'カスタマイズされた自動化ワークフローの構築',
      description:
        '当社の専門家が、お客さまのプロジェクトに最適化されたGitHub Actionsワークフローを設計・実装。複雑な開発プロセスを効率的に自動化し、開発者の生産性を向上させます。',
      src: '/images/LP/LP202407/img/img01.jpeg',
    },
    {
      num: '02',
      itemTitle: 'シームレスな外部サービス連携',
      description:
        'GitHub Actionsとさま々な外部サービスやツールとの連携をサポート。エキスパートが、クラウドサービスやデプロイ先環境との円滑な統合を実現し、エンドツーエンドの自動化を構築します。',
      src: '/images/LP/LP202407/img/img04.jpeg',
    },
    {
      num: '03',
      itemTitle: 'セキュリティと品質管理の自動化',
      description:
        'コードレビュー、テスト実行、セキュリティスキャンなどのプロセスを自動化。高品質かつ安全なコード開発サイクルを確立します。',
      src: '/images/LP/LP202407/img/img02.jpeg',
    },
  ],
}

const FlowContents = [
  {
    num: 1,
    title: '現状分析',
    description: 'お客さまの顧客コミュニケーション戦略と課題を詳細に分析します。',
    src: '/images/LP/LP202407/Icon/BsBarChartLine.svg',
  },
  {
    num: 2,
    title: 'ワークフロー設計',
    description: 'GitHub Actionsを活用した最適な自動化ワークフローを設計します。',
    src: '/images/LP/LP202407/Icon/BsDiagram3.svg',
  },
  {
    num: 3,
    title: '実装とテスト・運用支援',
    description: '設計したワークフローを実装し、十分なテストを行います。またスムーズな運用をサポートします。',
    src: '/images/LP/LP202407/Icon/BsPersonCheck.svg',
  },
]

const FAQContents = [
  {
    num: 1,
    question: 'GitHub Actionsは、どのような規模のプロジェクトに適していますか？',
    answer:
      'GitHub Actionsは、小規模なプロジェクトから大規模な企業レベルのプロジェクトまで、あらゆる規模に対応できます。プロジェクトの規模や要件に応じた最適な設定をサポートします。',
  },
  {
    num: 2,
    question: '既存のCI/CDツールからGitHub Actionsへの移行は難しいですか？',
    answer:
      '当社の専門チームが、スムーズな移行をサポートします。GitHub Actionsは多くの一般的なCI/CDタスクをサポートしており、既存のスクリプトやプロセスを活用しながら段階的に移行することが可能です。',
  },
  {
    num: 3,
    question: 'GitHub Actions導入により、具体的にどのような効果が期待できますか？',
    answer:
      '導入により、開発サイクルの短縮、人的ミスの削減、チーム間の連携強化、リリース頻度の向上などが期待できます。多くの場合、CI/CDプロセスの効率が30-50%向上したという報告があります。',
  },
  {
    num: 4,
    question: 'GitHub Actionsのコスト管理はどのように行われますか？',
    answer:
      'GitHub Actionsは一定の無料枠を提供しており、それを超えた場合に従量課金となります。お客さまの利用状況に応じた最適なコスト管理戦略を提案し、効率的な利用をサポートします。',
  },
  {
    num: 5,
    question: 'AitriaのGitHub Actions導入支援サービスの特徴は何ですか？',
    answer:
      '当社の特徴は、GitHub認定の専門家による手厚いサポート、豊富な自動化実績に基づく知見、お客さまのビジネスニーズに合わせたカスタマイズ能力です。また、導入後のトレーニングや継続的な最適化支援により、GitHub Actionsの利点を最大限に活用できるよう支援します。',
  },
]

const inPocketList = [
  {
    image: '/images/inPocket/Github Actions/knowledge_githubactions.png',
    title: 'GitHub Actionsとは？選ばれる理由と知っておくべき用語、料金体系を解説',
    date: '2024.8.30',
    href: 'https://aitria.co.jp/in-pocket/11623',
  },
  {
    image: '/images/inPocket/Github Actions/cicd_point.png',
    title: 'CI/CDとは？CI/CDツールを選ぶポイント7選＆ツール比較！',
    date: '2024.8.23',
    href: 'https://aitria.co.jp/in-pocket/11532',
  },
]

const topics = [
  {
    title:
      '特徴量エンジニアリングを使って生成AIによるUIデザインと画面レイアウトのアウトプットをコントロールする技術を開発',
    date: '2024年9月6日',
    src: '/pressrelease/3726',
  },
  {
    title: 'アート引越センターが提供する、AIが自動見積りをするアプリの開発支援をいたしました',
    date: '2024年5月21日',
    src: '/pressrelease/3369',
  },
  {
    title: '開発生産性の向上のためGitHubが提供する「GitHub Copilot」を導入',
    date: '2023年5月24日',
    src: '/pressrelease/2769',
  },
]

const CallToActionContents = {
  heading: ['作業の自動化で時間を節約！', 'GitHub Actionsを今すぐ導入しませんか？'],
}

const GitHubActions: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null)
  const contentsRef = useRef<HTMLDivElement>(null)

  useScrollHideContact(contactRef, contentsRef)
  return (
    <>
      <article className={styles.LPPage}>
        <div className={styles.contents} ref={contentsRef}>
          <Top contents={TopContents} paths={paths} />
          <Introduction contents={IntroductionContents} />
          <BestPractice contents={BestPracticeContents} />
          <Architecture contents={ArchitectureContents} />
          <Features contents={FeaturesContents} />
          <Flow contents={FlowContents} />
          <PriceList />
          <QA contents={FAQContents} />
          <NewsLp inPocketList={inPocketList} topics={topics} />
          <CallToAction contents={CallToActionContents} />
        </div>
        <div ref={contactRef} className={styles.contact_wrapper}>
          <Contact formId={ContactFormId} />
        </div>
        <div>
          <MailmagazineLink />
        </div>
      </article>
    </>
  )
}
export default GitHubActions
